
import { Vue, Prop, Component } from "vue-property-decorator";
 
@Component
export default class PeekPortrait extends Vue {
    // your photo (any image, shown as a square crop)
    @Prop({ required: true }) photo!: string;
    // side of the square, in px
    @Prop({ default: 180 }) size!: number;

    mounted() {}
}
